.link {
  /* No `display` override — native <a> is `inline`, which is exactly what
   * a link in running text needs. An earlier draft used `inline-flex` for
   * vertical centering, but that makes the anchor an atomic inline-level
   * box whose contents can't break across lines, so a long link would
   * overflow its parent instead of wrapping. Inline-flex would also
   * render the focus ring as a single box fragment around the whole
   * link — native inline rendering fragments the ring per line, which is
   * the expected browser behaviour for wrapped links. */

  /* 2px horizontal padding (Figma spec), zero vertical. Keeps the
   * clickable area snug against the visual text bounds so links sit
   * flush inline in prose. */
  padding-inline: var(--spacing-2);
  padding-block: 0;
  font-family: var(--font-family);
  font-weight: var(--text-weight-medium);
  color: var(--text-link);
  /* Default state: no underline. Underline appears on hover for affordance.
   * Figma shows no underline in the Default variant and defines no hover
   * variant, so the hover underline is an added usability convention. */
  text-decoration: none;
  transition:
    color var(--motion-duration-fast) ease,
    box-shadow var(--motion-duration-fast) ease;
}

.link:hover {
  text-decoration: underline;
}

.link:focus-visible {
  outline: none;
  /* Match Button / IconButton's Figma-derived 1px outset ring so sibling
   * interactive primitives share a consistent keyboard affordance.
   * --text-primary swaps light/dark automatically. */
  box-shadow: 0 0 0 1px var(--text-primary);
  /* A tiny radius on the ring so it doesn't clip on the narrow padding. */
  border-radius: var(--radius-2);
}

/* ─── Sizes ──────────────────────────────────────────────────────── */

/* xs — 12px text with --text-xs-tracking to match the tiny (Default/xs)
 * Button variants it sits next to in the Figma file (Figma "tracking: 1"
 * at 12px base = 0.12px). */
.size-xs {
  font-size: var(--text-size-xs);
  line-height: var(--text-lh-xs);
  letter-spacing: var(--text-xs-tracking);
}

/* s — 14px text. Default size. No explicit tracking (Figma spec sets
 * tracking: 0 for size=s). */
.size-s {
  font-size: var(--text-size-s);
  line-height: var(--text-lh-s);
}
